import { getRuntimeEnvironmentInfo } from "./runtime-environment-info";

/**
 * Adds a dark mode class to the body element if the application is not running in a web browser. 
 * This is so that the dark-mode CSS can be applied to components dynamically when in dark-mode.
 */
const addDarkModeClassToBodyIfNotInBrowser = (darkModeCssClassName = "dark-mode-webview") => {
    const { isBrowser } = getRuntimeEnvironmentInfo();
    if (!isBrowser) {
        document.body.classList.add(darkModeCssClassName);
    }
};

export const CssUtil = {
    addDarkModeClassToBodyIfNotInBrowser
}